import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ChartCard } from './ChartCard';
import type { ChartConfig, ChartMode, ChartSize } from '../../type/dynamicChart';
import type { Tool, Trace } from '@/features/traceability/type/Tool';

const sizeToColSpan: Record<ChartSize, string> = {
  sm: 'col-span-12 lg:col-span-3',
  md: 'col-span-12 lg:col-span-6',
  lg: 'col-span-12 lg:col-span-9',
  full: 'col-span-12',
};

type SortableChartCardProps = {
  chart: ChartConfig;
  traces: (Trace & { reference?: string })[];
  tools: Tool[];
  onUpdate: (updates: Partial<ChartConfig>) => void;
  onRemove: () => void;
  canRemove: boolean;
  mode?: ChartMode;
};

export function SortableChartCard({
  chart,
  traces,
  tools,
  onUpdate,
  onRemove,
  canRemove,
  mode,
}: SortableChartCardProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: chart.id,
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    ...(isDragging
      ? {
          boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
          zIndex: 10,
        }
      : {}),
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={sizeToColSpan[chart.layout.size]}
    >
      <ChartCard
        config={chart}
        traces={traces}
        tools={tools}
        onUpdate={onUpdate}
        onRemove={onRemove}
        canRemove={canRemove}
        mode={mode}
        isDragging={isDragging}
        dragHandleListeners={listeners as unknown as Record<string, unknown>}
        dragHandleAttributes={attributes as unknown as Record<string, unknown>}
      />
    </div>
  );
}
